import React, { Component } from 'react';
import { ANALYTICS_COLORS } from '../../ecs/constants';
import './Dot.scss';

class Dot extends Component {
  render() {
    const props = { className: 'dot' };
    if (this.props.colorIdx) {
      props.style = {
        backgroundColor: ANALYTICS_COLORS[this.props.colorIdx - 1]
      };
    } else if (this.props.color) {
      props.style = { backgroundColor: this.props.color };
    }

    return <span {...props} />;
  }
}

export default Dot;
